import * as XLSX from "xlsx";
import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";

const FieldDaysAttendance = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };
  const [data, setData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);
  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);
  const { sendRequest: getFieldDaysAttendanceData } = useHttp();

  const fillFieldDaysAttendanceData = (
    employeeId,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/fieldDaysAttendanceReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getFieldDaysAttendanceData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillFieldDaysAttendanceData(0, 0, "");
  }, [getFieldDaysAttendanceData]);

  const handleExportAttendanceExcel = async () => {
    setLoading(true);
  
    try {
      const getDownloadUrl = (path) => {
        if (!path) return "";
        return `${process.env.REACT_APP_FILE_URL}${path}`;
      };
  
      const processedData = currentItems.map((item, index) => ({
        "Promoter Id": item.employeeCode || "",
        "Agri Promoter Name": item.employeeName || "",
        "Doc No": item.docNo || "",
        "State": item.state || "",
        "LGA": item.lga || "",
        "Village Name": item.villageName || "",
        "Participant Name (Farmer)": item.farmerName || "",
        "Gender of Participant": item.gender || "",
        "Phone number": item.number || "",
        "Category of Attendees": item.categoryOfAttendees || "",
        "Active Farmer": item.isActiveAttendees ? "Yes" : "No",
        "Crop cultivated": item.cropName || "",
        "Farm size (Ha)": item.farmSizedHa || "",
        "Signature Link": getDownloadUrl(item.signature) || "No Signature",
        "Picture Link": getDownloadUrl(item.image) || "No Image",
      }));
  
      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
  
      XLSX.writeFile(workbook, "FieldDaysAttendance.xlsx");
    } catch (error) {
      console.error("Error exporting Excel:", error);
    }
  
    setLoading(false);
  };
  
  
  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForTargetAllocation/?useCase=Agri Promoter&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        console.log("emp", data);
        // var emplist = data;

        setEmployeeData(data.employeeList);
        setEmployeeAllData(data.employeeList);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Days Attendance Report
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Agri Promoter Name</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value !== "0") userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillFieldDaysAttendanceData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportAttendanceExcel}
                disabled={loading}
              >
                {loading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-file-excel"></i>
                )}
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>S/N</th>
                          <th>Promoter Id</th>
                          <th>Agri Promoter Name</th>
                          <th>Doc No</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village Name</th>
                          <th>Participant Name (Farmer)</th>
                          <th>Gender of Participant</th>
                          <th>Phone number</th>
                          <th>Category of Attendees</th>
                          <th>Active Farmer</th>
                          <th>Crop cultivated</th>
                          <th>Farm size (Ha)</th>
                          <th>Signature</th>
                          <th>Pictures captured</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{i + 1}</td>
                                <td>{itm.employeeCode || ""}</td>
                                <td>{itm.employeeName || ""}</td>
                                <td>{itm.docNo || ""}</td>
                                <td>{itm.state || ""}</td>
                                <td>{itm.lga || ""}</td>
                                <td>{itm.villageName || ""}</td>
                                <td>{itm.farmerName || ""}</td>
                                <td>{itm.gender || ""}</td>
                                <td>{itm.number || ""}</td>
                                <td>{itm.categoryOfAttendees || ""}</td>
                                <td>{itm.isActiveAttendees ? "Yes" : "No"}</td>
                                <td>{itm.cropName || ""}</td>
                                <td>{itm.farmSizedHa || ""}</td>
                                <td>
                                  {itm.signature ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.signature}`}
                                      alt="Signature"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Signature"
                                  )}
                                </td>

                                <td>
                                  {itm.image ? (
                                    <img
                                      src={`${process.env.REACT_APP_FILE_URL}${itm.image}`}
                                      alt="Farmer"
                                      width="50"
                                      height="50"
                                    />
                                  ) : (
                                    "No Image"
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FieldDaysAttendance;
